import { createSlice } from "@reduxjs/toolkit";

// Create a slice for payments
const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    paymentItems: [],
    payment: {},
    loading: false,
    error: null,
  },
  reducers: {
    setPaymentItems: (state, action) => {
      state.paymentItems = action.payload.data || [];
      state.loading = false;
    },
    setPayment: (state, action) => {
      state.payment = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectPaymentLoading = (state) => state.payment.loading;
export const selectPaymentError = (state) => state.payment.error;
export const selectPaymentItems = (state) => state.payment.paymentItems;
export const selectPayment = (state) => state.payment.payment;

// Export the reducer to include in the store
export const { setPayment, setPaymentItems } = paymentSlice.actions;
export default paymentSlice.reducer;
